import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import HiddenHorizontalScrollbar from '@/components/HiddenHorizontalScrollbar.vue';
import SingleStepEventEncounter from '@/features/sports/components/global/SingleStepEventEncounter.vue';
import Subheading from '@/features/sports/components/ui/Subheading.vue';

import { SingleStepContext } from '@/features/sports/helpers/config';
import { useI18n } from '@/helpers/composables/useI18n';

import { SingleStepSportEvent } from '@/@types/graphql-types';

import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'HeadToHead',
  props: {
    event: null,
    pastEvents: null,
    context: null
  },
  setup(__props: any) {

const props = __props as {
	event: SingleStepSportEvent;
	pastEvents: SingleStepSportEvent[];
	context: SingleStepContext;
};

const { t } = useI18n();
const { country } = storeToRefs(useLanguageStore());



const homeTeam = computed(() => props.event.competitors?.homeTeam.competitors[0].content.name);
const awayTeam = computed(() => props.event.competitors?.awayTeam.competitors[0].content.name);

const competitionName = computed(() => props.event.competition?.content.name);

const headToHead = computed(() => {
	let homeWins = 0;
	let awayWins = 0;

	props.pastEvents.forEach(event => {
		const homeScore = event.competitors.homeTeam.score ?? 0;
		const awayScore = event.competitors.awayTeam.score ?? 0;

		if (homeScore > awayScore) homeWins++;
		else if (awayScore > homeScore) awayWins++;
	});

	const totalMatches = props.pastEvents.length;
	const teamWithMostWins = awayWins > homeWins ? awayTeam.value : homeTeam.value;
	const teamWithMostLosses = awayWins < homeWins ? awayTeam.value : homeTeam.value;
	const mostWinsCount = awayWins > homeWins ? awayWins : homeWins;
	const leastWinsCount = awayWins < homeWins ? awayWins : homeWins;
	const mostWinsPercentage = ((mostWinsCount / totalMatches) * 100).toFixed(0);
	const leastWinsPercentage = ((leastWinsCount / totalMatches) * 100).toFixed(0);

	return {
		teamWithMostWins,
		teamWithMostLosses,
		mostWinsCount,
		leastWinsCount,
		mostWinsPercentage,
		leastWinsPercentage,
	};
});

const headToHeadSpinningText = computed(() => {
	const encounterCount = props.pastEvents.length;

	const earliestEvent = props.pastEvents[props.pastEvents.length - 1];
	const firstEncounterDate = Intl.DateTimeFormat(country.value, {
		month: '2-digit',
		day: '2-digit',
		year: 'numeric',
	}).format(new Date(earliestEvent.content.startAt));

	return t('WEBAPP_HEAD_TO_HEAD_SPINNING_TEXT', {
		homeTeam: homeTeam.value,
		awayTeam: awayTeam.value,
		competitionName: competitionName.value,
		encounterCount,
		firstEncounterDate,
		teamWithMostWins: headToHead.value.teamWithMostWins,
		mostWinsCount: headToHead.value.mostWinsCount,
		mostWinsPercentage: headToHead.value.mostWinsPercentage,
		teamWithMostLosses: headToHead.value.teamWithMostLosses,
		leastWinsCount: headToHead.value.leastWinsCount,
		leastWinsPercentage: headToHead.value.leastWinsPercentage,
	});
});

return { __sfc: true,t, country, props, homeTeam, awayTeam, competitionName, headToHead, headToHeadSpinningText, HiddenHorizontalScrollbar, SingleStepEventEncounter, Subheading }
}

})